import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Support from './support';
import SupportUpdate from './support-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={SupportUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={SupportUpdate} />
      <ErrorBoundaryRoute path={match.url} component={Support} />
    </Switch>
  </>
);

export default Routes;
